import { ComponentType, SVGProps } from 'react';
import { IconBottleService, IconCheckin, IconGuestList, IconInvitation, IconPass, IconTicket } from '@components/icons';

/**
 * Offer type identifiers
 */
export const OFFER_TYPE_TICKET = 'ticket';
export const OFFER_TYPE_BOTTLE_SERVICE = 'bottleservice';
export const OFFER_TYPE_GUEST_LIST = 'guestlist';
export const OFFER_TYPE_PASS = 'season_pass';
export const OFFER_TYPE_ACTIVE_PASS = 'active_pass';
export const OFFER_TYPE_INACTIVE_PASS = 'inactive_pass';
export const OFFER_TYPE_INVITATION = 'invitation';
export const OFFER_TYPE_ADDON = 'addons';
export const OFFER_TYPE_CHECKIN = 'checkin';

/**
 * Type for offer type identifiers
 */
export type OfferType =
  | typeof OFFER_TYPE_TICKET
  | typeof OFFER_TYPE_BOTTLE_SERVICE
  | typeof OFFER_TYPE_GUEST_LIST
  | typeof OFFER_TYPE_PASS
  | typeof OFFER_TYPE_ACTIVE_PASS
  | typeof OFFER_TYPE_INACTIVE_PASS
  | typeof OFFER_TYPE_INVITATION
  | typeof OFFER_TYPE_ADDON
  | typeof OFFER_TYPE_CHECKIN;

/**
 * Configuration interface for offer types
 */
export interface OfferTypeConfig {
  title: string;
  icon: ComponentType<SVGProps<SVGSVGElement>> | null;
  className: string;
  iconColor?: string;
}

/**
 * Offer types configuration object
 * Contains the visual and textual representation for each offer type
 */
export const OFFER_TYPES_CONFIG: Record<OfferType, OfferTypeConfig> = {
  [OFFER_TYPE_TICKET]: {
    title: 'eventReport:badgeTicketLabel',
    icon: IconTicket,
    className: 'bg-purple-50',
    iconColor: 'text-purple-500',
  },
  [OFFER_TYPE_BOTTLE_SERVICE]: {
    title: 'eventReport:badgeBottleServiceLabel',
    icon: IconBottleService,
    className: 'bg-orange-50',
    iconColor: 'text-orange-500',
  },
  [OFFER_TYPE_GUEST_LIST]: {
    title: 'eventReport:badgeGuestListLabel',
    icon: IconGuestList,
    className: 'bg-pink-50',
    iconColor: 'text-pink-500',
  },
  [OFFER_TYPE_PASS]: {
    title: 'eventReport:badgePassLabel',
    icon: IconPass,
    className: 'bg-turquoise-50',
    iconColor: 'text-turquoise-500',
  },
  [OFFER_TYPE_ACTIVE_PASS]: {
    title: 'eventReport:badgeActivePassLabel',
    icon: IconPass,
    className: 'bg-turquoise-50',
    iconColor: 'text-turquoise-500',
  },
  [OFFER_TYPE_INACTIVE_PASS]: {
    title: 'eventReport:badgeInactivePassLabel',
    icon: IconPass,
    className: 'bg-turquoise-50',
    iconColor: 'text-turquoise-500',
  },
  [OFFER_TYPE_INVITATION]: {
    title: 'eventReport:badgeInvitationLabel',
    icon: IconInvitation,
    className: 'bg-blue-50',
    iconColor: 'text-blue-500',
  },
  [OFFER_TYPE_ADDON]: {
    title: 'eventReport:addonTabLabel',
    icon: null,
    className: '',
  },
  [OFFER_TYPE_CHECKIN]: {
    title: 'eventReport:checkin',
    icon: IconCheckin,
    className: 'bg-yellow-50',
    iconColor: 'text-yellow-500',
  },
};
